<template>
  <div>
    <transition name="fade-transform" mode="out-in">
      <pack v-if="showList">
        <zt-title>授权方管理</zt-title>
        <!-- 搜索器 -->
        <form class="form" @submit.native.prevent @keyup.enter.exact="onSearch()">
          <span>小程序名称：</span>
          <zt-input placeholder="请输入小程序名称" v-model.trim="search.nick_name"></zt-input>

          <span>APPID：</span>
          <zt-input placeholder="请输入APPID" v-model.trim="search.appid"></zt-input>

          <span>ID：</span>
          <zt-input placeholder="请输入ID" v-model.trim="search.id"></zt-input>

          <span>审核结果：</span>
          <el-select v-model="search.check_status" placeholder="请选择">
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              v-model="item.value"
            ></el-option>
          </el-select>
          <span>线上版本：</span>
          <el-select v-model="search.now_version" placeholder="请选择">
            <el-option
              v-for="item in onlineList"
              :key="item.value"
              :label="item.label"
              v-model="item.value"
            ></el-option>
          </el-select>
          <span>是否过期：</span>
          <el-select v-model="search.expire" placeholder="请选择">
            <el-option
              v-for="item in expireList"
              :key="item.value"
              :label="item.label"
              v-model="item.value"
            ></el-option>
          </el-select>


          <zt-button type="primary" @click.exact.enter="onSearch">搜索</zt-button>
          <zt-button @click="clear">清空</zt-button>
          <div class="mt12 clearfix">
            <zt-button type="primary" class="fr" @click="reloadList">刷新列表</zt-button>
          </div>
        </form>

        <!-- table -->
        <el-table key="list" :data="list" ref="table" class="table" :load="loading">
          <el-table-column label="ID" prop="id" width="60px" />
          <el-table-column label="申请注册手机号" prop="telephone" width="130px" />
          <el-table-column label="小程序名称" prop="nick_name" width="100px" />
          <el-table-column label="小程序头像">
            <template slot-scope="{row}">
              <img :src="row.head_img" alt />
            </template>
          </el-table-column>
          <el-table-column label="小程序码">
            <template slot-scope="{row}">
              <img class="point" :src="row.qrcode_url" @click="showQrDialog(row.qrcode_url)" alt />
            </template>
          </el-table-column>
          <el-table-column label="过期时间" prop="expires_at">
            <template slot-scope="{row}">
              {{formatDate(row.expires_at*1000,'YYYY-MM-DD')}}
            </template>
          </el-table-column>
          <el-table-column label="APPID" prop="authorizer_appid" />

          <el-table-column label="授权时间">
            <template
              slot-scope="{row}"
            >{{row.authorizer_expires_at&&formatDate(row.authorizer_expires_at*1000,'YYYY-MM-DD')}}</template>
          </el-table-column>
          <el-table-column label="授权状态">
            <template slot-scope="{row}">
              <span>{{row.authorizer_status}}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态">
            <template slot-scope="{row}">
              <div :class="`${formapStatusClass(row.check_status)}`">
                <span>{{row.check_version}}</span>
                <br v-if="row.check_version" />
                <span>{{formapCheckVersion(row.check_status)||'未提交审核'}}</span>
                <br v-if="row.check_status===1" />
                <span v-if="row.check_status===1" v-html="`原因:${row.reason}`"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="线上版本" prop="now_version" />
          <el-table-column label="操作">
            <template slot-scope="{row}">
              <zt-button size="mini" @click="set(row)">设置</zt-button>
              <zt-button size="mini" type="danger" @click="del(row)">删除</zt-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页器 -->
        <div class="pagination">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="pagination.page"
            :page-sizes="pagesize"
            :page-size="pagination.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.recordcount"
          ></el-pagination>
        </div>
      </pack>
      <pack v-else>
        <zt-title>授权方管理-设置</zt-title>
        <zt-button @click="showList=true" type="primary" size="large">返回</zt-button>

        <!-- table -->
        <el-table key="tabList" :data="editList" ref="tableList" class="table">
          <el-table-column label="ID" prop="id" width="60px" />
          <el-table-column label="小程序名称" prop="nick_name" width="70px" />
          <el-table-column label="小程序头像">
            <template slot-scope="{row}">
              <img :src="row.head_img" alt />
            </template>
          </el-table-column>
          <el-table-column label="小程序码">
            <template slot-scope="{row}">
              <img class="point" :src="row.qrcode_url" @click="showQrDialog(row.qrcode_url)" alt />
            </template>
          </el-table-column>
          <el-table-column label="主体名称" prop="principal_name" />
          <el-table-column label="APPID" prop="authorizer_appid" />
          <el-table-column label="授权时间">
            <template slot-scope="{row}">{{row.authorizer_expires_at&&formatDate(row.authorizer_expires_at*1000,'YYYY-MM-DD')}}</template>
          </el-table-column>
          <el-table-column label="授权状态">
            <template slot-scope="{row}">
              <span>{{row.authorizer_status}}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态">
            <template slot-scope="{row}">
              <div :class="`${formapStatusClass(row.check_status)}`">
                <span>{{row.check_version}}</span>
                <br v-if="row.check_version" />
                <span>{{formapCheckVersion(row.check_status)||'未提交审核'}}</span>
                <br v-if="row.check_status===1" />
                <span v-if="row.check_status===1" v-html="`原因:${row.reason}`"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="审核模式">
            <template slot-scope="{row}">
              <el-switch v-loading="loadingChangeApplying" :value="row.applying" :active-value="1"  @change="toChangeApplying(row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="线上版本" prop="now_version" />
        </el-table>

        <!-- tab -->
        <el-tabs v-model="activeName" class="tab">
          <el-tab-pane label="服务器域名" name="0">
            <program-host :editList="editList" />
          </el-tab-pane>
          <!-- <el-tab-pane label="业务域名" name="1">
            <serviceHost :editList="editList" />
          </el-tab-pane>-->
          <el-tab-pane label="版本管理" name="1">
            <versonManage :editList="editList" :active="activeName" />
          </el-tab-pane>
          <el-tab-pane label="审核通知" name="2">
            <auditNotice :editList="editList" :active="activeName" />
          </el-tab-pane>
        </el-tabs>
      </pack>
    </transition>
    <el-dialog :visible.sync="qrDialog" width="300px" :show-close="false" top="300px">
        <img class="qrimg" :src="qrUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import programHost from "./components/programHost";
import serviceHost from "./components/serviceHost";
import versonManage from "./components/versonManage";
import auditNotice from "./components/auditNotice";
import {
  admin_plugin_wxapp_list,
  admin_plugin_wxapp_api,
  admin_plugin_wxapp_version_list,
  admin_plugin_wxapp_delete,
  admin_plugin_wxapp_refresh_authorizer_info,
} from "@/api/program";
import { formatDate } from "@/utils/date";
import admin_plugin_wxapp_apply from "@/api/admin_plugin_wxapp_apply";
export default {
  name: "adminManage",
  components: {
    programHost,
    serviceHost,
    versonManage,
    auditNotice,
  },
  data: () => ({
    qrUrl:"",
    qrDialog:false,
    activeName: 0,
    showList: true,
    pagesize: [10, 20, 30, 40],
    pagination: {
      page: 1, // 当前页
      pagesize: 10, // 每页大小
      pagecount: 1, // 总页数
      recordcount: 0, // 总条数
    },
    search: {
      id: "",
      nick_name: "",
      appid: "",
      check_status: "",
      now_version: "",
      expire: "",
    },
    editList: [],
    list: [],
    loading: false,
    stateList: [
      {
        value: "",
        label: "全部",
      },
      {
        value: -1,
        label: "未提交审核",
      },
      {
        value: 0,
        label: "审核通过",
      },
      {
        value: 1,
        label: "审核被拒绝",
      },
      {
        value: 2,
        label: "审核中",
      },
      {
        value: 3,
        label: "已撤回",
      },
      {
        value: 4,
        label: "审核延后",
      },
    ],
    onlineList: [
      {
        label: "全部",
        value: "",
      },
    ],
    expireList: [
      {
        label: "全部",
        value: "",
      },
      {
        label: "已过期",
        value: 1,
      },
      {
        label: "未过期",
        value: 0,
      },
    ],
    loadingChangeApplying: false
  }),
  methods: {
    showQrDialog(qrUrl) {
      this.qrUrl = qrUrl
      this.qrDialog = true
    },
    reloadList() {
      admin_plugin_wxapp_refresh_authorizer_info().then(({ data }) => {
        if (data.error_code === 0) {
          this.clear();
          this.$message.success("刷新列表数据成功")
        } else {
          this.$message.error(data.error_message);
        }
      });
    },
    formapStatusClass(check_status) {
      switch (check_status) {
        case 0:
          return "success";
          break;
        case 1:
          return "danger";
          break;
        case 2:
          return "warn";
          break;
        case 3:
          return "";
          break;
        case 4:
          return "danger";
          break;
        default:
          return "";
      }
    },
    formapCheckVersion(check_status) {
      switch (check_status) {
        case -1:
          return "未提交审核";
          break;
        case 0:
          return "审核通过";
          break;
        case 1:
          return "审核被拒绝";
          break;
        case 2:
          return "审核中";
          break;
        case 3:
          return "已撤回";
          break;
        case 4:
          return "审核延后";
          break;
        default:
          return "";
      }
    },
    formatDate,
    // 更改 - 分页大小
    onSizeChange(pagesize) {
      this.pagination.pagesize = pagesize;
      this.getList();
    },
    // 更改 - 当前页
    onCurrentChange(page) {
      this.pagination.page = page;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const { data } = await admin_plugin_wxapp_list({
        ...this.pagination,
        ...this.search,
      });
      this.loading = false;
      if (data.error_code == 0) {
        this.list = data.list;
        this.pagination.recordcount = data.total_count;
        this.pagination.pagecount = data.page_count;
      } else {
        this.$message.error(data.error_message);
      }
    },
    set(row) {
      this.editList = [];
      console.log(row)
      this.editList.push(row);
      this.showList = false;
    },
    del(row) {
      this.$confirm("确定删除该小程序?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          admin_plugin_wxapp_delete({ id: row.id }).then(({ data }) => {
            if (data.error_code == 0) {
              this.$message.success("删除小程序成功");
            } else {
              this.$message.error(data.error_code);
            }
            this.getList();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onSearch() {
      Object.assign(this.pagination, this.$options.data().pagination)
      this.getList();
    },
    clear() {
      Object.assign(this.pagination, this.$options.data().pagination)
      Object.assign(this.search, this.$options.data().search)
      this.getList();
    },
    // 获取所有代码模板列表
    getTemplateList() {
      admin_plugin_wxapp_version_list().then(({ data }) => {
        if (data.error_code == 0) {
          const { versions } = data;
          versions.map((arr) => {
            this.onlineList.push({
              label: arr,
              value: arr,
            });
          });
        } else {
          this.$message.error(data.error_message);
        }
      });
    },
    // 切换审核模式
    async toChangeApplying({id, applying}) {
      applying = Number(!applying)
      this.loadingChangeApplying = true
      const {data} = await admin_plugin_wxapp_apply(id, applying)
      this.loadingChangeApplying = false
      if(data.error_code === 0) {
        if(this.editList && this.editList[0]) {
          const item = this.editList[0]
          item.applying = applying
          this.editList = [item]
        }
      }else {
        this.$message.success(data.error_message)
      }
    }
  },
  activated() {
    this.list = [];
    this.onlineList = [];
    this.getList();
    this.getTemplateList();
  },
  mounted() {
    this.getList();
    this.getTemplateList();
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f7f2ff;
}
.table {
  margin-top: 30px;
  /deep/ .cell {
    text-align: center;
  }

  img {
    width: 80px;
  }
}
/deep/ .el-button--mini {
  display: inline-block !important;
  margin-right: 10px !important;
}
.tab {
  margin-top: 30px;
}
.form {
  margin-top: 30px;
  font-size: 12px;
  span {
    display: inline-block;
    margin-left: 15px;
    margin-right: 5px;
  }

  /deep/ .zt-input {
    width: 150px;
    margin-right: 5px;
  }
  /deep/ .el-select {
    width: 139px;
  }
  /deep/ .zt-button {
    margin-left: 20px;
  }
}
.danger {
  color: #ff6a6a;
}
.success {
  color: #38af36;
}
.warn {
  color: #ec8f27;
}
/deep/ .el-dialog__header{
  padding: 0;
}
.qrimg {
  width: 250px;
  height: 250px;
}
.point{
  cursor: pointer;
}
</style>
